/**
 * Who may delete a forecast version, lock or unlock one, or choose the primary forecast. In a
 * governed org (`forecast_approvals_required` on the org settings) that is org admins and
 * MarginWiz staff; everywhere else everyone, as before. Mirrors `can_manage_forecast_versions`
 * on the server, which refuses the same calls; the UI hides the controls so a sales rep is not
 * offered a button that fails. (1st Phorm, Bakhrom 10/27: "no one should be able to delete the
 * Primary forecast, only myself". Sanzo and Saffron Road plan with no org admins and stay open.)
 */
export function can_manage_forecast_versions(user: { role?: string } | null | undefined, approvals_required: boolean): boolean {
  return !approvals_required || is_forecast_admin(user)
}

/** Org admins and MarginWiz staff: who reviews the approval queue, whatever the org setting. */
export function is_forecast_admin(user: { role?: string } | null | undefined): boolean {
  return user?.role === "system_admin" || user?.role === "org_admin"
}

if (import.meta.vitest) {
  const { describe, expect, it } = import.meta.vitest

  describe("can_manage_forecast_versions", () => {
    it("admits only admins and staff when the org is governed", () => {
      expect(can_manage_forecast_versions({ role: "org_admin" }, true)).toBe(true)
      expect(can_manage_forecast_versions({ role: "system_admin" }, true)).toBe(true)
      expect(can_manage_forecast_versions({ role: "user" }, true)).toBe(false)
      expect(can_manage_forecast_versions({ role: "broker" }, true)).toBe(false)
      expect(can_manage_forecast_versions({ role: "consultant" }, true)).toBe(false)
      expect(can_manage_forecast_versions(null, true)).toBe(false)
    })

    it("admits everyone when the org has not switched governance on", () => {
      expect(can_manage_forecast_versions({ role: "user" }, false)).toBe(true)
      expect(can_manage_forecast_versions({ role: "broker" }, false)).toBe(true)
      expect(is_forecast_admin({ role: "user" })).toBe(false)
    })
  })
}
